"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const atoms_1 = require("../../atoms");
const SimpleCard = ({ title, children, className }) => {
    return (react_1.default.createElement(atoms_1.Card, { className: className },
        react_1.default.createElement("dl", null,
            react_1.default.createElement("dt", { className: "mb-4 dark:text-gray-300 text-gray-500 text-sm font-medium leading-5 truncate" }, title),
            react_1.default.createElement("dd", { className: "mt-1 h-32 text-gray-900 text-3xl font-semibold leading-9" }, children))));
};
exports.default = SimpleCard;
